import button from './button';
import checkbox from './checkbox';
import code from './code';
import colour from './colour';
import content from './content';
import dropdown from './dropdown';
import form from './form';
import grid from './grid';
import icon from './icon';
import input from './input';
import layout from './layout';
import legend from './legend';
import loader from './loader';
import map from './map';
import modal from './modal';
import multiple from './multiple';
import navigation from './navigation';
import notification from './notification';
import radio from './radio';
import range from './range';
import select from './select';
import table from './table';
import textarea from './textarea';
import time from './time';
import toggle from './toggle';
import tree from './tree';
import util from './util';
import visualisation from './visualisation';

const components = [
  ...button,
  ...checkbox,
  ...code,
  ...colour,
  ...content,
  ...dropdown,
  ...form,
  ...grid,
  ...icon,
  ...input,
  ...layout,
  ...legend,
  ...loader,
  ...map,
  ...modal,
  ...multiple,
  ...navigation,
  ...notification,
  ...radio,
  ...range,
  ...select,
  ...table,
  ...textarea,
  ...time,
  ...tree,
  ...toggle,
  ...util,
  ...visualisation,
];

export const hyphenate = (str) => str.replace(/\B([A-Z])/g, '-$1').toLowerCase();

export function installComponents(vue) {
  components.forEach((component) => {
    let { name } = component;

    // Check if the component is already built (with .extend or defineComponent)
    if (!name.startsWith('Dp') && component.options) {
      // Registering fully built components needs an override for the name that is already
      // in kebab-case, because PascalCase seems to not work
      name = hyphenate(component.options.name);
    }
    vue.component(name, component);
  });
}
